import React, { useState, useEffect } from 'react';
import './Hero.css';

// Authentic animated Solari split-flap tile
const SplitFlapTile = ({ targetChar, delay = 0, triggerCycle = 0 }) => {
  const [currentChar, setCurrentChar] = useState(' ');
  const [isFlipping, setIsFlipping] = useState(false);

  useEffect(() => {
    if (targetChar === ' ') {
      setCurrentChar(' ');
      return;
    }

    const CHAR_SET = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789:,-./!';
    const targetIdx = CHAR_SET.indexOf(targetChar.toUpperCase());
    const finalTarget = targetIdx === -1 ? targetChar : CHAR_SET[targetIdx];

    let step = 0;
    // Do 4-6 mechanical rapid flips before settling on target
    const totalFlips = Math.floor(Math.random() * 4) + 4;

    const startTimeout = setTimeout(() => {
      const interval = setInterval(() => {
        step++;
        setIsFlipping(true);
        if (step >= totalFlips) {
          setCurrentChar(finalTarget);
          setIsFlipping(false);
          clearInterval(interval);
        } else {
          const randomChar = CHAR_SET[Math.floor(Math.random() * CHAR_SET.length)];
          setCurrentChar(randomChar);
        }
      }, 70);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(startTimeout);
  }, [targetChar, delay, triggerCycle]);

  if (targetChar === ' ') {
    return <span className="flap-tile flap-space">&nbsp;</span>;
  }

  return (
    <span className={`flap-tile ${isFlipping ? 'flipping' : ''}`}>
      <span className="flap-half flap-top">
        <span className="flap-text">{currentChar}</span>
      </span>
      <span className="flap-half flap-bottom">
        <span className="flap-text">{currentChar}</span>
      </span>
      <span className="flap-divider" />
    </span>
  );
};

const SplitFlapBoard = ({ text }) => {
  const [cycle, setCycle] = useState(0);

  // Repeat the flip cycle every 1000ms (1s) after flipping completes
  useEffect(() => {
    // 1000ms pause between flip cycles
    const REPEAT_INTERVAL_MS = 3000;

    const timer = setInterval(() => {
      setCycle((prev) => prev + 1);
    }, REPEAT_INTERVAL_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="split-flap-board" aria-label={text} role="status">
      <div className="split-flap-inner">
        {text.split('').map((char, i) => (
          <SplitFlapTile 
            key={`${i}-${char}`} 
            targetChar={char} 
            delay={i * 50} 
            triggerCycle={cycle}
          />
        ))}
      </div>
    </div>
  );
};

const Hero = () => {
  // Generate steam particles
  const particles = Array.from({ length: 15 }).map((_, i) => (
    <div 
      key={i} 
      className="steam-particle" 
      style={{
        left: `${Math.random() * 100}%`,
        animationDuration: `${Math.random() * 8 + 7}s`,
        animationDelay: `${Math.random() * 5}s`,
        width: `${Math.random() * 150 + 50}px`,
        height: `${Math.random() * 150 + 50}px`
      }}
    ></div>
  ));

  return (
    <header id="home" className="hero">
      <div className="steam-container">
        {particles}
      </div>
      <div className="hero-content container">
        <h1 className="hero-title">
          Pyro Pot
        </h1>

        <p className="hero-tagline">Where Every Pot Tells a Story.</p>
        <SplitFlapBoard text="GRAND OPENING: OCT 26, 2026" />

        <div className="hero-actions">
          <a href="#menu" className="btn btn-primary">View Menu</a>
          {/* <a href="#contact" className="btn btn-outline">Book a Table</a> */}
        </div>
      </div>
    </header>
  );
};

export default Hero;
